
import { Component, Vue, Watch } from 'vue-property-decorator';
import DeviceTable from './_DeviceTable.vue';
import DeviceDetail from './_DeviceDetail.vue';
import { iNetbar } from '../../../interface/result';
@Component({
  components: {
    DeviceTable,
    DeviceDetail,
  },
})
export default class TerminalImport extends Vue {
  private dynamComp = 'DeviceTable';
  private rowDetail: iNetbar = {
    id: 0,
    name: '',
    area_name: '',
    wan: '',
    isp: '',
    region_id: '',
    area_id: '',
    addr: '',
    uplink: '',
    cmd_port: 0,
    is_public: 0,
  };
  handleBack() {
    this.dynamComp = 'DeviceTable';
  }

  goInfo(obj: iNetbar) {
    this.dynamComp = 'DeviceDetail';
    this.rowDetail = obj;
  }
  mounted() {
    if (this.$route.params.row !== undefined) {
      this.dynamComp = 'DeviceDetail'; // area_id
      this.rowDetail = JSON.parse(decodeURIComponent(this.$route.params.row));
      this.rowDetail.id = Number(this.rowDetail.area_id);
      this.rowDetail.name = String(this.rowDetail.area_name);
    }
  }
}
